import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import logo from '../Assets/Images/Homepage/gif.png'
import { useNavigate } from "react-router-dom";

const industries = [
    {
        title: "Financial Technology / Digital Finance",
        image: "Images/Services/wolfpack-front.png",
        value: "wolfpack",
    },
    {
        title: "Customer Experience & Retail Insights",
        image: "Images/Services/mysterymanagement-front.png",
        value: "mysterymanagement",
    },
    {
        title: "Sports & Athletics",
        image: "Images/Services/wefroth-front.png",
        value: "wefroth",
    },
    {
        title: "Gaming & Predictive Analytics",
        image: "Images/Services/betodyssey-front.png",
        value: "betodyssey"
    },
    {
        title: "Automotive Industry / Mobility Solutions",
        image: "Images/Services/redarc-front.png",
        value: "redarc"
    },
    {
        title: "Media & Entertainment",
        image: "Images/Services/miromar-front.png",
        value: "miroamer"
    },
    {
        title: "Social Fitness & Wellness",
        image: "Images/Services/tandm-front.png",
        value: "tandm"
    },
    {
        title: "Human Resources & Talent Acquisition",
        image: "Images/Services/skilljobs-front.png",
        value: "skilljobs"
    },
    {
        title: "E-Commerce & Digital Retail",
        image: "Images/Services/juicelabs-front.png",
        value: "juicelabs"
    },
    {
        title: "Network & Communication Services",
        image: "Images/Services/belong-front.png",
        value: "belong"
    },
];



const IndustriesSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const sectionsRef = useRef([]);
    const navigate = useNavigate()

    useEffect(() => {
        let ticking = false;

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const viewportCenter = window.innerHeight / 2;

                    let closestIndex = 0;
                    let smallestDistance = Infinity;

                    sectionsRef.current.forEach((section, index) => {
                        if (!section) return;

                        const rect = section.getBoundingClientRect();
                        const elementCenter = rect.top + rect.height / 2;
                        const distance = Math.abs(viewportCenter - elementCenter);

                        if (distance < smallestDistance) {
                            smallestDistance = distance;
                            closestIndex = index;
                        }
                    });

                    setActiveIndex(prev =>
                        prev !== closestIndex ? closestIndex : prev
                    );

                    ticking = false;
                });

                ticking = true;
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    const handleClick = (index) => {
        // const section = sectionsRef.current[index];
        setActiveIndex(index)
        // if (section) {
        //     section.scrollIntoView({
        //         behavior: "smooth",
        //         block: "center",
        //     });
        // }
    };
    return (
        <Box>
            <Typography className="fs-52 text-color-main mb-2" gutterBottom>Industries we Serve </Typography>
            <Grid container alignItems={'center'} spacing={4}>
                {/* LEFT SIDE */}
                <Grid item size={{ xs: 12, md: 6, lg: 8 }}>

                    {industries.map((industry, index) => (
                        <Box
                            key={index}

                        >
                            <Typography
                                ref={(el) => (sectionsRef.current[index] = el)}
                                onMouseEnter={() => handleClick(index)}
                                width={'fit-content'}
                                className={`fs-28 fw-bold  ${activeIndex === index ? 'text-color-main' : 'text-grey'}`}
                                sx={{ transition: "0.3s", }}>
                                {industry.title}
                            </Typography>
                        </Box>
                    ))}
                </Grid>

                {/* RIGHT SIDE */}
                <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                    <Box
                        className='border-10'
                        sx={{
                            position: "sticky",
                            top: "100px",
                            // borderRadius: 3,
                            overflow: "hidden",
                            boxShadow: 3,
                            height: "100%"
                        }}
                    >
                        <Box
                            onClick={() => { navigate(`/client-details/${industries[activeIndex]?.value}`) }}
                            component="img"
                            src={industries[activeIndex].image ?? logo}
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "fill",
                                transition: "0.4s ease-in-out",
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box >
    );
};

export default IndustriesSection;
